import { Action } from '@ngrx/store';
import { UserPreferences } from '../../models/user-preferences.model';

export const GET_USER_PREFERENCES = '[User Preferences] Get Preferences';
export const GET_USER_PREFERENCES_FAIL = '[User Preferences] Get Preferences Fail';
export const GET_USER_PREFERENCES_SUCCESS = '[User Preferences] Get Preferences Success';

export const ADD_OR_UPDATE_USER_PREFERENCES = '[User Preferences] Add or Update Preferences';
export const ADD_OR_UPDATE_USER_PREFERENCES_FAIL = '[User Preferences] Add or Update Preferences Fail';
export const ADD_OR_UPDATE_USER_PREFERENCES_SUCCESS = '[User Preferences] Add or Update Preferences Success';

export const RESET_USER_PREFERENCES_CRUD = '[User Preferences] Reset CRUD';
export const CLEAR_USER_PREFERENCES_LIST = '[User Preferences] Clear List';

export class GetUserPreferences implements Action {
    readonly type = GET_USER_PREFERENCES;
    constructor(public payload: { tabName: string }) { }
}

export class GetUserPreferencesSuccess implements Action {
    readonly type = GET_USER_PREFERENCES_SUCCESS;
    constructor(public payload: any) { }
}

export class GetUserPreferencesFail implements Action {
    readonly type = GET_USER_PREFERENCES_FAIL;
    constructor(public payload: any) { }
}

export class AddOrUpdateUserPreferences implements Action {
    readonly type = ADD_OR_UPDATE_USER_PREFERENCES;
    constructor(public payload: UserPreferences) { }
}

export class AddOrUpdateUserPreferencesSuccess implements Action {
    readonly type = ADD_OR_UPDATE_USER_PREFERENCES_SUCCESS;
    constructor(public payload: any) { }
}

export class AddOrUpdateUserPreferencesFail implements Action {
    readonly type = ADD_OR_UPDATE_USER_PREFERENCES_FAIL;
    constructor(public payload: any) { }
}

export class ResetUserPreferencesCRUD implements Action {
    readonly type = RESET_USER_PREFERENCES_CRUD;
    constructor(public payload: any = null) { }
}


export class ClearUserPreferencesList implements Action {
    readonly type = CLEAR_USER_PREFERENCES_LIST;
    constructor(public payload: any = null) { }
}


export type UserPreferencesActions =
    | GetUserPreferences
    | GetUserPreferencesSuccess
    | GetUserPreferencesFail
    | AddOrUpdateUserPreferences
    | AddOrUpdateUserPreferencesSuccess
    | AddOrUpdateUserPreferencesFail
    | ResetUserPreferencesCRUD
    | ClearUserPreferencesList
    ;
